/** Диагональная штриховка с точками для бетонных стен. */
import { DotHatch, LineHatch, type WallHatchProps } from "./WallHatchGeometry";

export const ConcreteHatch = ({ outline }: WallHatchProps) => (
	<>
		<LineHatch outline={outline} angle={45} spacing={8} />
		<DotHatch outline={outline} spacing={8} />
	</>
);
